__turbopack_context__.v({
  "button": "ActionCard-module__BwtdwW__button",
  "card": "ActionCard-module__BwtdwW__card",
  "compact": "ActionCard-module__BwtdwW__compact",
  "contentHorizontal": "ActionCard-module__BwtdwW__contentHorizontal",
  "contentVertical": "ActionCard-module__BwtdwW__contentVertical",
  "disabled": "ActionCard-module__BwtdwW__disabled",
  "gapHorizontal": "ActionCard-module__BwtdwW__gapHorizontal",
  "gapVertical": "ActionCard-module__BwtdwW__gapVertical",
  "hero": "ActionCard-module__BwtdwW__hero",
  "horizontal": "ActionCard-module__BwtdwW__horizontal",
  "minimal": "ActionCard-module__BwtdwW__minimal",
  "textContent": "ActionCard-module__BwtdwW__textContent",
  "textContentHorizontal": "ActionCard-module__BwtdwW__textContentHorizontal",
  "vertical": "ActionCard-module__BwtdwW__vertical",
});
